(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rapido-gallery-blog-post"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.vehicle-gallery').forEach(function (gallery) {
      var grid = gallery.querySelector('.vehicle-gallery__grid');
      var lightbox = gallery.querySelector('.vehicle-gallery__lightbox');
      var openButtons = gallery.querySelectorAll('[data-gallery-open]');
      var lightboxImages = gallery.querySelectorAll('.vehicle-gallery__lightbox-image');
      var currentLabel = gallery.querySelector('[data-lightbox-current]');
      var mobileLabel = gallery.querySelector('[data-gallery-current]');
      var closeButton = lightbox && lightbox.querySelector('[data-gallery-close]');
      var previousButton = lightbox && lightbox.querySelector('[data-gallery-previous]');
      var nextButton = lightbox && lightbox.querySelector('[data-gallery-next]');
      var activeIndex = 0;
      var lastFocusedElement;

      if (
        !grid ||
        !lightbox ||
        !lightboxImages.length ||
        !closeButton ||
        !previousButton ||
        !nextButton
      ) {
        return;
      }

      document.body.appendChild(lightbox);

      function showImage(index) {
        activeIndex = (index + lightboxImages.length) % lightboxImages.length;

        lightboxImages.forEach(function (image, imageIndex) {
          image.classList.toggle('is-active', imageIndex === activeIndex);
        });

        if (currentLabel) {
          currentLabel.textContent = activeIndex + 1;
        }
      }

      function openLightbox(index) {
        lastFocusedElement = document.activeElement;
        showImage(index);
        lightbox.hidden = false;
        document.body.classList.add('vehicle-gallery-open');
        closeButton.focus();
      }

      function closeLightbox() {
        lightbox.hidden = true;
        document.body.classList.remove('vehicle-gallery-open');

        if (lastFocusedElement) {
          lastFocusedElement.focus();
        }
      }

      openButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          openLightbox(Number(button.dataset.galleryOpen));
        });
      });

      closeButton.addEventListener('click', closeLightbox);

      previousButton.addEventListener('click', function () {
        showImage(activeIndex - 1);
      });

      nextButton.addEventListener('click', function () {
        showImage(activeIndex + 1);
      });

      lightbox.addEventListener('click', function (event) {
        if (event.target === lightbox) {
          closeLightbox();
        }
      });

      document.addEventListener('keydown', function (event) {
        if (lightbox.hidden) {
          return;
        }

        if (event.key === 'Escape') {
          closeLightbox();
        }

        if (event.key === 'ArrowLeft') {
          showImage(activeIndex - 1);
        }

        if (event.key === 'ArrowRight') {
          showImage(activeIndex + 1);
        }
      });

      if (mobileLabel && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                mobileLabel.textContent =
                  Number(entry.target.dataset.galleryOpen) + 1;
              }
            });
          },
          {
            root: grid,
            threshold: 0.7
          }
        );

        openButtons.forEach(function (button) {
          observer.observe(button);
        });
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
